import Page from "../.."
import Forbbiden from "../../Error/forbbiden"

const PageConsultoriaIncidentes = () => {
    return(
        <Page conteudo={({ open }) => <Forbbiden />} />
    )
}

export default PageConsultoriaIncidentes